// core version + navigation, pagination modules:
import Swiper, {
  Navigation, Pagination, Autoplay, EffectFade
} from 'swiper';

const moment = require('moment');

export default () => {
  const heroSwipers = document.getElementsByClassName('hero-swiper');
  for (let i = 0; i < heroSwipers.length; i++) {
    const heroSwiperId = '#' + heroSwipers[i].id;
    // init Swiper:
    // eslint-disable-next-line no-unused-vars
    const heroSwiper = new Swiper(heroSwiperId, {
      // configure Swiper to use modules
      modules: [ Navigation, Pagination, Autoplay, EffectFade ],
      slidesPerView: 1,
      centeredSlides: true,
      speed: 200,
      loop: true,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true
      },
      effect: 'fade',
      // If we need pagination
      pagination: {
        // el: '#swiper-pagination-' + heroSwipers[i].id,
        el: '.hero-swiper-pagination',
        clickable: true
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar'
      }
    });
  }
  // eslint-disable-next-line no-unused-vars
  const reviewSwiper = new Swiper('.review-swiper', {
    // configure Swiper to use modules
    modules: [ Navigation, Pagination, Autoplay ],
    slidesPerView: 1,
    centeredSlides: true,
    speed: 200,
    loop: true,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true
    },
    // If we need pagination
    pagination: {
      el: '.review-swiper-pagination',
      clickable: true
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar'
    }
  });

  // eslint-disable-next-line no-unused-vars
  function dateWithSuffix(date) {
    return moment(date).format('MMMM Do, YYYY');
  };
};
